import { type SnippetsClientInterface } from './snippetsClient.types';
import CorporateSnippetsClient from './corporateSnippetsClient';
import GroupSnippetsClient from './groupSnippetsClient';
import OrgUnitSnippetsClient from './orgUnitSnippetsClient';
import type { ClientContext } from '~/services/contextClient';

export default class SnippetsClientFactory {
    static createClient(context: ClientContext): SnippetsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateSnippetsClient(context.teamId);
        } else if (context.orgUnitId) {
            return new OrgUnitSnippetsClient(context.teamId, context.orgUnitId);
        } else if (context.groupId) {
            return new GroupSnippetsClient(context.teamId, context.groupId);
        }

        throw new Error('Invalid context');
    }
}
